/* eslint-disable eqeqeq */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  btnLoading: false,
  reload: false,
  profileVideos: [],
};

const profileVideoSlice = createSlice({
  name: "profileVideo",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setBtnLoading: (state, action) => {
      state.btnLoading = action.payload;
    },
    setReload: (state, action) => {
      state.reload = action.payload;
    },
    setProfileVideos: (state, action) => {
      state.profileVideos = action.payload;
    },
    setProfileVideosInsert: (state, action) => {
      state.profileVideos.push(action.payload);
    },
    setProfileVideoDelete: (state, action) => {
      const results = state.profileVideos.filter(
        (item) => item.id != action.payload,
      );
      state.profileVideos = results;
    },
  },
});

export const {
  setLoading,
  setBtnLoading,
  setReload,
  setProfileVideos,
  setProfileVideosInsert,
  setProfileVideoDelete,
} = profileVideoSlice.actions;
export default profileVideoSlice.reducer;
